<template>
  <b-container>
    <h2>{{ $t("bi.powerbiview.list") }}</h2>
    <success-fade-alert ref="alert" :msg="msg.success" />
    <fade-alert-danger ref="danger" :msg="msg.error" />

    <b-row class="mb-3 ml-0">
      <router-link :to="'../edit/' + companyId.toString()">
        <b-button size="sm">{{ $t("geral.back") }}</b-button>
      </router-link>
      <router-link class="ml-2" :to="'../bicreate/' + companyId.toString()">
        <b-button size="sm">{{ $t("geral.create") }}</b-button>
      </router-link>
    </b-row>

    <b-row>
      <b-table
        ref="MyForm"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template v-slot:cell(actions)="data">
          <router-link :to="'../biedit/' + data.item.id + '/' + companyId">
            <b-button size="sm">{{ $t("geral.editar") }}</b-button>
          </router-link>
          <!-- @click="deleteField(row)" -->
          <b-button size="sm" @click="deleteRow(data.item.id)" class="ml-2">
            {{ $t("geral.delete") }}
          </b-button>
        </template>
      </b-table>
    </b-row>
    <b-row>
      <b-col>
        <b-pagination
          v-model="tableCurrentPage"
          :total-rows="tableRowCount"
          :per-page="tablePerPage"
          first-number
          last-number
          aria-controls="table-tabela-proceda"
        />
      </b-col>
      <b-col>
        <label for="perPageSelect"
          >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de
          {{ tableRowCount }}</label
        >
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <b-form-select
              v-model="tablePerPage"
              id="perPageSelect"
              size="sm"
              :options="tablePageOptions"
            />
          </b-col>
          <b-col>
            <label for="perPageSelect">Registros exibidos por página</label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
  },
  props: {
    companyId: String,
  },
  data: function () {
    return {
      msg: {
        success: "",
        error: "",
      },
      isBusy: false,
      fields: [
        {
          key: "actions",
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "sidebarTitle",
          label: this.$t("geral.displayName"),
          sortable: true,
        },
      ],
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  methods: {
    deleteRow(id) {
      this.$apiScheduler
        .get(`/powerbiview/delete/${id}/${this.companyId}`)
        .then((response) => {
          this.msg.success = this.$t("geralmsgs.deleteSuccess");
          this.$refs.MyForm.refresh();
          this.$refs.alert.show();
        })
        .catch((error) => {
          this.msg.error = this.$t("geralmsgs.deleteError") + " - " + error;
          this.$refs.danger.show();
        });
    },
    myProvider(ctx, callback) {
      this.isBusy = true;

      let apiFilter = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
        companyId: parseInt(this.companyId),
      };

      this.$apiScheduler
        .post("/powerbiview/all/", apiFilter)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.msg.error = this.$t("geralmsgs.loadError") + " - " + error;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });

      return null;
    },
  },
};
</script>

